<script setup>
import { onBeforeMount, onMounted, ref } from 'vue'
import PMTemplateListItemForm from './Form.vue'
import PMTemplateListItemIndex from './Index.vue'

const editId = ref()
/** @type {import('vue').Ref<InstanceType<typeof PMTemplateListItemIndex>>} */
const pmTemplateListItemIndexRef = ref(null)

onBeforeMount(() => {
  const url = new URL(window.location.href)
  const index = parseInt(url.searchParams.get('ei'), 10)
  if (Number.isNaN(index) || !index) return
  editId.value = index
})

/**
 * Description
 * @param {PMTemplateListItem['id']} itemId
 */
const onEditHandler = (itemId) => {
  const url = new URL(window.location.href)
  url.searchParams.set('ei', String(itemId))
  window.history.replaceState({}, '', url.href)
  editId.value = itemId
  pmTemplateListItemIndexRef.value.getPMTemplateItems()
}

const onCancelHandler = () => {
  const url = new URL(window.location.href)
  url.searchParams.delete('ei')
  window.history.replaceState({}, '', url.href)
  editId.value = null
}

const onSuccessHandler = () => {
  pmTemplateListItemIndexRef.value.getPMTemplateItems()
}
</script>
<style scoped lang="sass">
.pm-template-list-item
  display: flex
  gap: 10px
  .index
    flex: 1
.box-bubble
  border: 1px solid #cfcdcd
  padding: 10px
  border-radius: 10px
</style>
<template>
  <div class="pm-template-list-item">
    <div class="box-bubble">
      <PMTemplateListItemForm
        :edit-id="editId"
        @on-success="onSuccessHandler"
        @on-cancel="onCancelHandler"
      />
    </div>
    <div class="box-bubble index">
      <PMTemplateListItemIndex ref="pmTemplateListItemIndexRef" @on-edit="onEditHandler" />
    </div>
  </div>
</template>
<script>
/**
 * @typedef {import('./Index.vue').PreventiveMaintenanceTemplateItem} PMTemplateListItem
 */
</script>
